import type * as React from 'react';

import type { CommentListProps } from '@xing-com/crate-social-types';
import { useHost } from '@xing-com/crate-xinglet';

import { CommentListSkeleton } from '../comment-list-skeleton/comment-list-skeleton';

export type { CommentListProps };

export const CommentList: React.VFC<CommentListProps> = (props) => {
  const { XingletLoader } = useHost();

  return (
    <XingletLoader
      name="@xing-com/crate-social-comment-list-xinglet"
      fallback={<CommentListSkeleton />}
      {...props}
    />
  );
};
